// Only memory, cleared when the page takes ownership. Never persist this value.
let initialToken = null;

export function readAndRemoveFragment() {
  const { pathname, search, hash } = window.location;
  if (pathname.replace(/\/$/, '') !== '/oferta') return null;
  const token = new URLSearchParams(hash.slice(1)).get('t');
  if (hash)
    window.history.replaceState(window.history.state, '', pathname + search);
  return token || null;
}

export function captureInitialOfferToken() {
  initialToken = readAndRemoveFragment();
}

export function takeOfferToken() {
  const token = readAndRemoveFragment() || initialToken;
  initialToken = null;
  return token;
}
